
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/[section]",
      function () {
        return require("private-next-pages/education/[section]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/[section]"])
      });
    }
  